/**
 * Created by mac on 12/24/20
 */

const Mineable = function (unit, options) {
    UnitComponent.call(this, unit);

    const unitData = cleverapps.clone(this.unit.getData(), true);
    this.data = unitData.mineable;

    this.mined = options.mined || 0;
    this.state = options.state || (unitData.mined ? Mineable.STATES.FINISHED : Mineable.STATES.WAIT);

    if ((this.state === Mineable.STATES.FINISHED || cleverapps.gameModes.initMineableWithPrizes) && !this.isCompleted() && !unit.getData().manualPrizes) {
        this.unit.setPrizes(this.listPrize(), this.getTask().exp);
    }

    // Migration for stuck
    if (!unitData.monster && this.state === Mineable.STATES.FINISHED && unit.prizes === undefined) {
        this.state = Mineable.STATES.WAIT;
    }

    if (this.data.missionReward) {
        cleverapps.missionManager.on("add", this.onMissionUpdate.bind(this), this);
        cleverapps.missionManager.on("complete", this.onMissionUpdate.bind(this), this);
        cleverapps.missionManager.on("startStage", this.onMissionUpdate.bind(this), this);
        cleverapps.missionManager.on("stopStage", this.onMissionUpdate.bind(this), this);
        cleverapps.missionManager.on("showPointsSources", this.onShowPointsSources.bind(this), this);
    }

    this.onNeedToBeRemoved();
};

Mineable.prototype = Object.create(UnitComponent.prototype);
Mineable.prototype.constructor = Mineable;

Mineable.prototype.onPrizeHarvested = function () {
    this.nextPosition();
};

Mineable.prototype.onNeedToBeRemoved = function () {
    if (this.isCompleted() || cleverapps.gameModes.easyChop) {
        Map2d.mapEvent(Map2d.MINE, { affected: this.unit });

        this.giveMissionsRewards([Mission.TYPE_HUNGRY_GAMES]);

        this.unit.movable = false;
        const delay = this.unit.getData().collectOnComplete ? 0 : 1000 * Map2d.animationsTimeScale();
        this.timeout = setTimeout(() => {
            delete this.timeout;

            const generator = this.unit.findComponent(Merge3Generator);
            const monster = this.unit.findComponent(Monster);
            if (generator) {
                generator.gotoNextLevel();
            } else if (monster) {
                monster.die();
            } else {
                const growing = this.unit.findComponent(Growing);
                if (growing) {
                    growing.remove();
                }
                this.unit.onDestruction();
                this.unit.remove(true);

                Map2d.currentMap.blockedGrounds.updateBlockedGrounds();

                cleverapps.tutorial.trigger(Map2d.REMOVED_MINING, {
                    unit: this.unit
                });
            }
        }, delay);
    }
};

Mineable.prototype.onInfoOpened = function () {
    this.onUpdateState();
};

Mineable.prototype.onInfoClosed = function (withAction) {
    if (!withAction) {
        this.onUpdateState();

        const task = this.getTask();
        if (task && task.energy && !cleverapps.lives.canTake(task.energy) && cleverapps.specialEnergyOffer && cleverapps.specialEnergyOffer.isReady()) {
            cleverapps.specialEnergyOffer.wantsToShow();
        }
    }
};

Mineable.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

Mineable.prototype.onMissionUpdate = function (mission) {
    if (this.data.missionReward.some((reward) => reward.missionType === mission.type)) {
        this.onUpdateState();
    }
};

Mineable.prototype.onShowPointsSources = function (mission) {
    if (this.data.missionReward.some((reward) => reward.missionType === mission.type)) {
        this.onUpdateState();

        Mineable.FindMissionSource(mission.type);
    }
};

Mineable.prototype.onRemoveFreePrizeView = function () {
    if (this.view) {
        this.view.removeFreePrize(true);
    }
};

Mineable.prototype.handleClick = function () {
    const data = this.unit.getData();
    const isInfoViewShown = Map2d.currentMap.pathIndicator && Map2d.currentMap.pathIndicator.isInfoViewShown(this.unit) || InfoView.IsDisplayedFor(this.unit);

    if (this.isFree() || isInfoViewShown && data.harvestOnSecondClick) {
        const cantShowInfo = Map2dLocation.currentLocation.tutorial.isActive() && !Map2dLocation.currentLocation.tutorial.checkConditions({ move: this.unit })
            || cleverapps.tutorial.isActive() && !(
                cleverapps.tutorial.checkConditions({ move: this.unit })
                || (data.harvestOnSecondClick && cleverapps.tutorial.checkConditions({ unit: this.unit }))
            );
        if (!Map2d.currentMap.dragging && !cantShowInfo) {
            this.unit.squeeze();

            if (isInfoViewShown) {
                InfoView.CloseInfo(true);
            }

            this.startMine();
        }
        return true;
    }
};

Mineable.prototype.save = function (data) {
    if (this.mined) {
        data.mined = this.mined;
    }

    if (this.state !== Mineable.STATES.WAIT) {
        data.state = this.state;
    }
};

Mineable.prototype.listPrize = function () {
    const generator = this.unit.findComponent(Merge3Generator);
    this.unit.seedRandom(this.mined + (generator ? generator.changedLevels * 10 : 0));

    const info = Mines[this.unit.getType()](this.mined, this.unit);
    if (info) {
        return Prizes.Generate(cleverapps.toArray(info));
    }
    return [];
};

Mineable.prototype.listAvailablePrizes = function () {
    const info = Mines[this.unit.getType()](this.mined, this.unit);
    return Prizes.Generate(cleverapps.toArray(info), { listOnly: true });
};

Mineable.prototype.getTask = function () {
    const task = this.data.tasks[this.mined];

    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (task && !locationConfig.usesEnergy) {
        task.energy = 0;
    }

    return task;
};

Mineable.prototype.isFree = function () {
    const locationConfig = cleverapps.meta.getSelectedLocation().locationConfig;
    if (!locationConfig.usesEnergy) {
        return false;
    }

    const task = this.getTask();
    if (!task || task.energy !== 0) {
        return false;
    }

    if (this.unit.prizes) {
        return false;
    }

    if (Map2d.currentMap.workers.findAssigned(this.unit)) {
        return false;
    }

    if (this.unit.isLockedUnit()) {
        return false;
    }

    return true;
};

Mineable.prototype.startMine = function () {
    if (Map2d.currentMap.workers.findAssigned(this.unit)) {
        return false;
    }

    if (Map2d.currentMap.workers.findInstantAssigned(this)) {
        return false;
    }

    if (this.isCompleted()) {
        return false;
    }

    const task = this.getTask();
    if (!task) {
        cleverapps.throwAsync(`no task for mineable ${this.unit.code}_${this.unit.stage}_${this.mined} ${this.unit.x}_${this.unit.y}`);
        return false;
    }

    const worker = Map2d.currentMap.workers.findFree(this.unit, true);
    if (!worker) {
        Map2dLocation.currentLocation.workersBusyHint(this.unit);
        return false;
    }

    if (!Map2dLocation.currentLocation.confirmEnoughEnergy(task.energy)) {
        return false;
    }

    if (!worker.assign(this.unit, cleverapps.parseInterval(task.time))) {
        return false;
    }

    if (task.energy) {
        Map2dLocation.currentLocation.useEnergy(task.energy, this.unit);
    }

    const data = { unit: this.unit };
    Map2d.mapEvent(Map2d.START_MINING, data);
    cleverapps.tutorial.trigger(Map2d.START_MINING, data);
    
    this.onRemoveFreePrizeView();

    return true;
};

Mineable.prototype.completeMining = function () {
    this.onRemoveFreePrizeView();

    const data = this.unit.getData();
    const task = this.getTask();

    if (data.manualPrizes) {
        this.state = Mineable.STATES.FINISHED;
        this.unit.save();
    } else if (data.collectOnComplete) {
        this.mined++;
        this.unit.save();
        this.onNeedToBeRemoved();
    } else {
        const prizes = this.listPrize();
        const noPrizes = !prizes || prizes.length === 0;
        this.state = noPrizes ? Mineable.STATES.WAIT : Mineable.STATES.FINISHED;
        if (!noPrizes) {
            this.unit.setPrizes(prizes, this.getTask().exp);
        }
    }

    const options = {
        unit: this.unit,
        task
    };
    Map2d.mapEvent(Map2d.COMPLETE_MINING, options);
    cleverapps.tutorial.trigger(Map2d.COMPLETE_MINING, options);

    if ((data.autoCollect || cleverapps.gameModes.easyChop) && !data.collectOnComplete) {
        this.unit.takePrizes({
            effect: `worker.mining.${this.unit.code}`
        });
    }
};

Mineable.prototype.isCompleted = function () {
    return this.mined >= this.countStages();
};

Mineable.prototype.countStages = function () {
    return this.data.tasks.length;
};

Mineable.prototype.nextPosition = function () {
    this.mined++;

    this.state = Mineable.STATES.WAIT;
    this.unit.save();

    this.onUpdateState();
};

Mineable.prototype.reset = function () {
    this.mined = 0;
    this.state = Mineable.STATES.WAIT;

    this.unit.movable = this.unit.getData().movable;

    this.onUpdateState();
};

Mineable.prototype.destructor = function () {
    runCleaners(this);

    if (this.timeout) {
        clearTimeout(this.timeout);
        delete this.timeout;
    }
};

Mineable.prototype.getActionInfo = function () {
    const locked = this.unit.findComponent(LockedComponent);
    if (locked && (locked.isLockActive() || locked.isUnlockInProcess())) {
        return;
    }

    if (this.state !== Mineable.STATES.WAIT || this.isCompleted()) {
        return;
    }

    const data = this.unit.getData();
    const duration = cleverapps.parseInterval(this.getTask().time);
    const generator = this.unit.findComponent(Merge3Generator);
    const buttons = {
        energy: {
            isQuick: duration === 0,
            action: this.startMine.bind(this),
            energy: this.getTask().energy
        }
    };
    if (
        !this.unit.isGrounded()
        && cleverapps.meta.getSelectedLocation().locationConfig.deleteGeneratedSources
    ) {
        buttons.delete = {
            unit: this.unit
        };
    }
    const info = {
        simpleInfo: data.simpleInfo,
        title: this.unit,
        duration,
        generator: generator && generator.getGeneratorInfo(),
        buttons
    };

    info.progress = {
        value: this.mined,
        total: this.countStages()
    };

    return info;
};

Mineable.prototype.giveMissionsRewards = function (excludedMissions) {
    this.listActiveMissionRewards().forEach((missionReward) => {
        if ((excludedMissions || []).indexOf(missionReward.missionType) !== -1) {
            return;
        }

        const reward = new Reward("mission", missionReward);
        reward.receiveReward();

        if (this.view) {
            this.view.giveMissionReward(missionReward.missionType, () => reward.onAnimationFinished());
        } else {
            reward.onAnimationFinished();
        }
    });
};

Mineable.prototype.listActiveMissionRewards = function () {
    return cleverapps.toArray(this.data.missionReward || []).filter((reward) => {
        const mission = cleverapps.missionManager.findByType(reward.missionType);
        if (!mission || !mission.isRunning() || mission.logic && mission.logic.isRunning && !mission.logic.isRunning()) {
            return false;
        }
        if (mission.logic && mission.logic.hasMineableRewards && !mission.logic.hasMineableRewards()) {
            return false;
        }
        return true;
    });
};

Mineable.prototype.lockStateUpdate = function () {
    this.onUpdateState();
};

Mineable.prototype.handlePrizes = function () {
    if (this.view) {
        this.view.handlePrizes();
    }
};

Mineable.FindMissionSource = cleverapps.throttle(50, (missionType) => {
    const position = Map2d.currentMap.getScreenCenterCell();
    const units = Map2d.currentMap.listAvailableUnits((unit) => {
        const data = unit.getData();
        const hasMissionReward = data.mineable
            && data.mineable.missionReward
            && data.mineable.missionReward.some((reward) => reward.missionType === missionType);
        const isGenerator = unit.getType() && unit.getType().includes("generator");
        return hasMissionReward || isGenerator;
    }).sort((a, b) => {
        const aIsGenerator = a.getType() && a.getType().includes("generator");
        const bIsGenerator = b.getType() && b.getType().includes("generator");
        if (aIsGenerator && bIsGenerator || (!aIsGenerator && !bIsGenerator)) {
            return cc.pDistanceSQ(position, a) - cc.pDistanceSQ(position, b);
        }
        return aIsGenerator ? 1 : -1;
    });

    if (units.length === 0) {
        cleverapps.notification.create(Messages.get("Quest.find.empty"));
        return;
    }

    Map2d.currentMap.focusOnUnit(units[0], {
        allowScrollWithFocus: true,
        skipFocusReport: true,
        callback: function () {
            FingerView.hintTap({ x: units[0].x, y: units[0].y }, { runOnce: true });
        }
    });
});
Mineable.STATES = {
    WAIT: 0,
    FINISHED: 1
};